// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import '@yaradigitallabs/ahua-react/fonts/noto-sans/font-face.css';
import '@yaradigitallabs/ahua-react/fonts/yara-max/font-face.css';
import { setupGlobalErrorHandlers } from '@/utils/errorHandler';
import { setupAPIInstanceInterceptor } from '@/api/authorizedAPI';

import { store } from './app/store';
import { NotificationProvider } from './components/notification/useNotification.tsx';
import App from './App.tsx';
import './index.css';

setupAPIInstanceInterceptor(store.dispatch);

// Setup global error handlers for clipboard and other permission errors
setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </BrowserRouter>
  </Provider>
  // </StrictMode>
);
